<template>
  <div>
    <section class="hero-section banner">
      <img src="@/assets/header.webp" alt="" class="hero-bg" aria-hidden="true">
      <div class="container hero-inner">
        <div class="row align-items-center">
          <div class="col-lg-5 hero-content">
            <img src="@/assets/horga-x-logo2.webp" alt="HORGA X" class="hero-logo mb-3">
            <h1 class="hero-title">รวมสินค้าและบริการ<br>สำหรับธุรกิจอสังหาฯ ปล่อยเช่า</h1>
            <a href="tel:021069769" class="btn btn-call">
              <i class="fas fa-phone-alt mr-2"></i>โทรตอนนี้
            </a>
          </div>
          <div class="col-lg-7 hero-products d-none d-lg-block">
            <img src="@/assets/commerce-platform.webp" alt="สินค้าและบริการ HORGA X" class="img-fluid">
          </div>
        </div>
      </div>
    </section>
    <!-- <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="7"></li>
      </ol>
      <div class="carousel-inner" style="border-radius: 0px 0px 3px 3px; border: 1px solid rgba(148, 148, 148, 0.5);">
        <div class="carousel-item active">
          <router-link :to="`/productdetail/YVNcmxkrmG`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/banner/k-qr.jpg"
              alt="card-reader"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/productdetail/dLxUr3xT7p`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/banner/beneat.png"
              alt="card-reader"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/productdetail/mgPZziEFg6`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/banner/beam.jpg"
              alt="card-reader"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/list?category=smart-apartment`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/banner/frt.png"
              alt="card-reader"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/productdetail/rWco618dfj`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/banner/card-reader-gen2.jpg"
              alt="card-reader"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/productdetail/fdvFCGWkuv`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/branner/payment.jpg"
              alt="Second slide"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/productdetail/Zgw9G5gLMm`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/branner/creative.jpg"
              alt="First slide"
            />
          </router-link>
        </div>
        <div class="carousel-item">
          <router-link :to="`/productdetail/FFGz6WxJyE`">
            <img
              class="d-block w-100 img-fluid"
              src="@/assets/images/branner/OnTheTop.jpg"
              alt="Second slide"
            />
          </router-link>
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span>
          <i class="fa fa-angle-left btn-slide" aria-hidden="true"></i>
        </span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span>
          <i class="fa fa-angle-right btn-slide" aria-hidden="true"></i>
        </span>
        <span class="sr-only">Next</span>
      </a>
    </div> -->
    <!-- <div class="image-brand">
      <img src="@/assets/images/brand.png" />
    </div> -->
    <slot/>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState([
      'user'
    ])
  },
}
</script>
<style scoped>
.hero-section {
  position: relative;
  overflow: hidden;
  min-height: 380px;
  padding: 48px 0 56px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.hero-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}
.banner {
  z-index: 1;
}
.banner::before {
  content: '';
  position: absolute;
  background: conic-gradient(
    from 0deg,
    #B8C9F5,
    #7953F6,
    #6EC1E8,
    #1D79C3,
    #000166
  );
  filter: blur(100px);
  top: 3%;
  left: 45%;
  width: 50%;
  height: 100%;
  z-index: 1;
  transform-origin: center center;
  animation: spin-gradient 15s linear infinite;
  opacity: 0.5;
}
@keyframes spin-gradient {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.hero-inner {
  position: relative;
  z-index: 2;
}
.hero-logo {
  height: 40px;
}
.hero-title {
  color: #fff;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 24px;
}
.btn-call {
  background: #1a1a1a;
  color: #fff;
  border-radius: 50px;
  padding: 10px 28px;
  font-size: 16px;
  font-weight: 600;
  border: none;
}
.btn-call:hover {
  background: #333;
  color: #fff;
  text-decoration: none;
}
.hero-products img {
  max-height: 320px;
  width: 100%;
  object-fit: contain;
  object-position: right center;
}
@media only screen and (max-width: 991px) {
  .hero-section {
    padding: 32px 0 40px;
  }
  .hero-title {
    font-size: 1.5rem;
  }
}
@media only screen and (max-width: 768px) {
  .hero-section {
    min-height: auto;
    padding: 24px 0 32px;
  }
  .hero-inner {
    padding-left: 16px;
    padding-right: 16px;
  }
  .hero-title {
    font-size: 1.25rem;
    margin-bottom: 16px;
  }
  .hero-logo {
    height: 32px;
  }
  .banner::before {
    left: 20%;
    width: 80%;
  }
}
.header {
  border: 1px solid black;
}
.menuSearch {
  width: 100%;
  text-align: right;
  margin-top: -30px;
  padding-right: 20px;
}
.menuSearch input {
  color: #8c8c8c;
  border: 1px solid #8c8c8c;
  border-radius: 10px;
  padding-left: 30px;
  width: 220px;
}
.menuSearch i {
  position: absolute;
  padding-top: 7px;
  color: #8c8c8c;
  padding-left: 10px;
}
.carousel-item img{
  transition: all 100ms;
}
.carousel-item:hover img{
  opacity: .7;
}
.carousel-control-prev:hover {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.3), #ffffff00);
}
.carousel-control-next:hover {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.3), #ffffff00);
}
.btn-slide {
  color: rgb(255, 255, 255);
  font-size: 40px;
  text-shadow: 2px 2px 5px black;
}
.carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid var(--primary);
  background-color: #ffffff;
  opacity: 1;
  box-shadow: 3px 2px 5px black;
}
.carousel-indicators li.active {
  background-color: var(--primary);
}
.image-brand {
  text-align: center;
  margin: 20px;
  /* border: 1px solid black; */
}
.image-brand img {
  width: 150px;
  filter: brightness(50%);
}
.container {
  padding-top: 20px;
  padding-bottom: 20px;
  max-width: 1300px;
}

.purchase-info-phone{
  color: rgb(80, 80, 80);
  cursor: pointer;
  display: none;
  font-weight: bold;
}
.purchase-info-phone .item{
  text-align: center;
  font-weight: bold;
}
.purchase-info-phone .item:nth-child(1) , .purchase-info-phone .item:nth-child(2){
  border-right: 1px solid rgba(148, 148, 148, 0.5);
}
.purchase-info-phone .item i{
  font-size: 30px;
  margin-bottom: 10px;
}
.product-fillter{
  text-align: right;
  position: relative;
  height: 45px;
}
.fillter-item{
  position: absolute;
  right: 10px;
  text-align: center;
  top: 0;
}
.borderBottom {
  width: 120px;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 1px solid var(--primary);
}

.box-col{
  padding: 15px;
  background-color: white;
  /* box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2); */
  border-radius: 3px;
  margin-bottom: 15px;
  border: 1px solid rgba(148, 148, 148, 0.5);
}
.box-col a{
  color: rgb(80, 80, 80);
  text-decoration: none;
}
.main-topic{
  margin-top: 20px;
  margin-bottom: 0px;
}
.purchase-info-desktop{
  list-style-type: none;
  padding: 30px 30px 15px 30px;
  font-weight: bold;
  cursor: pointer;
  color: rgb(80, 80, 80);
}
.purchase-info-desktop.menu li{
  margin-bottom: 20px;
}
.purchase-info-desktop.menu i{
  margin-right: 10px;
}
.purchase-info-desktop.menu li:hover{
  text-decoration: underline;
}
.link:hover{
  text-decoration: underline;
}
.purchase-info-desktop i{
  font-size: 25px;
  width: 35px;
}
.purchase-info-desktop .angle{
  float: right;
  text-align: right;
  width: auto;
}

@media only screen and (max-width: 991px) {
  .purchase-info-desktop{
    display: none;
  }
  .purchase-info-phone{
    display: block;
  }
}
@media only screen and (max-width: 768px) {
  .main {
    padding-top: 10px;
  }
  .hero-inner.container {
    padding-left: 16px;
    padding-right: 16px;
  }
  .menuSearch input {
    width: 0px;
    border: none;
  }
  .menuSearch i {
    cursor: pointer;
  }
  .carousel-indicators li {
    width: 7px;
    height: 7px;
    border: 1px solid var(--primary);
  }
  .btn-slide {
    font-size: 25px;
  }
  .box-col{
    margin-bottom: 0;
    box-shadow: none;
    margin: 15px 15px 0px 15px;
  }
}
</style>

